import {MaturePassengerModel} from "../../passenger/mature-passenger.model";
import {
    COMPANION_TYPES_FOR_REDUCED_MOBILITY,
    PassengerTypeCodesEnum, WITH_CHILD_TYPE_CODES_MAPPINGS
} from "../../../../passenger-types/passenger-type-codes.enum";


export class PassengerTypeMutator {
    constructor(public readonly passenger: MaturePassengerModel) {

    }

    get hasReducedMobility(): boolean {
        const passengerSegment = this.passenger.booking.getAllFilteredPassengersSegments().find(ps => ps.passenger.passengerIndex === this.passenger.passengerIndex);
        if(!passengerSegment) {
            return false;
        }
        return passengerSegment.getSoldSsrsEditors().some(ssr => ssr.ssrType.benefitPsoReducedMobilityDiscount);
    }


    applyReducedMobilityCompanion(): boolean {
        if(!this.passenger.passengerType.isAdult) {
            throw new Error('applyReducedMobilityCompanion should only be called for adults');
        }

        if(this.hasReducedMobility) {
            throw new Error('applyReducedMobilityCompanion should not be called for passengers with reduced mobility');
        }

        const passengerType = this.passenger.scheduledPassengerTypeChange ?? this.passenger.passengerType.code;
        if(COMPANION_TYPES_FOR_REDUCED_MOBILITY.includes(passengerType)) {
            this.passenger.scheduledPassengerTypeChange = PassengerTypeCodesEnum.AdultWithReducedMobility; //companions for passengers with reduced mobility gets the same passenger type
            return true;
        }

        return false;
    }

    clearReducedMobilityCompanion(): void {
        if(!this.passenger.passengerType.isAdult) {
            throw new Error('clearReducedMobilityCompanion should only be called for adults');
        }

        if(this.hasReducedMobility) {
            throw new Error('clearReducedMobilityCompanion should not be called for passengers with reduced mobility');
        }

        const passengerType = this.passenger.scheduledPassengerTypeChange ?? this.passenger.passengerType.code;

        if(COMPANION_TYPES_FOR_REDUCED_MOBILITY.includes(passengerType)) {
            this.passenger.scheduledPassengerTypeChange = this.passenger.originalPassengerTypeCode;
        }

    }

    applyChildCompanion(): void {
        if(!this.passenger.passengerType.isAdult) {
            throw new Error('applyChildCompanion should only be called for adults');
        }

        if(this.hasReducedMobility) {
            throw new Error('applyChildCompanion should not be called for passengers with reduced mobility');
        }

        const passengerType = this.passenger.scheduledPassengerTypeChange ?? this.passenger.passengerType.code;

        const companionWithChildType = WITH_CHILD_TYPE_CODES_MAPPINGS[passengerType];
        if(companionWithChildType) {
            this.passenger.scheduledPassengerTypeChange = companionWithChildType;
        }

    }

}